const CALENDARIO_EVENTO = "segreteria@algores.it";
const CALENDARIO_DEM = "c_b4b24nd83eolg6eqk05rmb9cq4@group.calendar.google.com";
const CALENDARIO_SUITECRM = "c_b4b24nd83eolg6eqk05rmb9cq4@group.calendar.google.com";

// Crea un evento su un calendario con invitati
async function creaEventoCalendar(accessToken, calendarId, titolo, inizioISO, fineISO, descrizione = "", invitati = []) {
  const url = `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(calendarId)}/events`;
  const body = {
    summary: titolo,
    description: descrizione,
    start: { dateTime: inizioISO, timeZone: "Europe/Rome" },
    end: { dateTime: fineISO, timeZone: "Europe/Rome" },
    attendees: invitati.map((email) => ({ email })),
  };
  const res = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) {
    console.error(`Errore creazione evento su ${calendarId}:`, data);
    return null;
  }
  console.log(`Evento creato su ${calendarId}:`, data);
  return data.id || null;
}

// Aggiorna un evento esistente
async function aggiornaEventoCalendar(accessToken, calendarId, eventId, titolo, inizioISO, fineISO, descrizione = "", invitati = []) {
  const url = `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(calendarId)}/events/${eventId}`;
  const body = {
    summary: titolo,
    description: descrizione,
    start: { dateTime: inizioISO, timeZone: "Europe/Rome" },
    end: { dateTime: fineISO, timeZone: "Europe/Rome" },
    attendees: invitati.map((email) => ({ email })),
  };
  const res = await fetch(url, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) {
    console.error(`Errore aggiornamento evento su ${calendarId}:`, data);
    return null;
  }
  console.log(`Evento aggiornato su ${calendarId}:`, data);
  return data.id || null;
}

function sottraiMinuti(datetimeLocal, minuti) {
  const d = new Date(datetimeLocal);
  d.setMinutes(d.getMinutes() - minuti);
  return d.toISOString();
}

function aggiungiMinuti(datetimeLocal, minuti) {
  const d = new Date(datetimeLocal);
  d.setMinutes(d.getMinutes() + minuti);
  return d.toISOString();
}

function giornoSuccessivoOre12(dataRiferimento) {
  const d = new Date(dataRiferimento);
  d.setDate(d.getDate() + 1);
  d.setHours(12, 0, 0, 0);
  return d.toISOString();
}

function giornoSuccessivoOre1215(dataRiferimento) {
  const d = new Date(dataRiferimento);
  d.setDate(d.getDate() + 1);
  d.setHours(12, 15, 0, 0);
  return d.toISOString();
}

// Costruisce la descrizione per il reminder evento
function buildDescrizioneEvento(evento, nomeCliente, nomiResponsabili) {
  return [
    `Titolo: ${evento.titolo || "—"}`,
    `Cliente: ${nomeCliente || "—"}`,
    `Referenti: ${nomiResponsabili || "—"}`,
    `Tipo: ${evento.tipoEvento || "—"}`,
    `Tecnologia: ${Array.isArray(evento.tecnologie) ? evento.tecnologie.join(", ") : "—"}`,
  ].join("\n");
}

// Verifica se titolo, data o ora sono cambiati rispetto al vecchio evento
export function deveCreaereOAggiornareCalendar(eventoNuovo, eventoVecchio) {
  if (!eventoVecchio) return "crea";
  const campiRilevanti = ["titolo", "dataInizio", "oraInizio", "dataFine", "oraFine", "demInvito", "demReminder", "demPromemoria", "demSurvey", "dataSurvey"];
  for (const campo of campiRilevanti) {
    if (eventoNuovo[campo] !== eventoVecchio[campo]) return "aggiorna";
  }
  if (JSON.stringify(eventoNuovo.giornate) !== JSON.stringify(eventoVecchio.giornate)) return "aggiorna";
  return "nessuna";
}

// Funzione principale
export async function gestisciReminderCalendar(accessToken, evento, eventoVecchio, impostazioni, nomeCliente, nomiResponsabili) {
  const azione = eventoVecchio?.stato === "chiusoAcquisito"
    ? deveCreaereOAggiornareCalendar(evento, eventoVecchio)
    : "crea";

  if (azione === "nessuna") {
    console.log("Nessuna modifica rilevante, calendar non aggiornato");
    return null;
  }

  const invitatiEvento = impostazioni?.invitatiEvento || [];
  const invitatiDEM = impostazioni?.invitatiDEM || [];
  const invitatiSuiteCRM = impostazioni?.invitatiSuiteCRM || [];
  const descrizioneEvento = buildDescrizioneEvento(evento, nomeCliente, nomiResponsabili);
  const idEventiCalendar = eventoVecchio?.idEventiCalendar || {};
  const nuoviIdEventi = { ...idEventiCalendar };

  // ── REMINDER DEM ──────────────────────────────────────────
  if (evento.demAttiva) {
    const campiDEM = [
      { campo: evento.demInvito, label: "Invio DEM - Invito", key: "demInvito" },
      { campo: evento.demReminder, label: "Invio DEM - Reminder", key: "demReminder" },
      { campo: evento.demPromemoria, label: "Invio DEM - Promemoria", key: "demPromemoria" },
    ];

    for (const { campo, label, key } of campiDEM) {
      if (!campo) continue;
      const inizio = sottraiMinuti(campo, 15);
      const fine = aggiungiMinuti(campo, 10);
      const titolo = `${label} - ${evento.titolo}`;
      const idEsistente = idEventiCalendar[key];

      if (azione === "aggiorna" && idEsistente) {
        await aggiornaEventoCalendar(accessToken, CALENDARIO_DEM, idEsistente, titolo, inizio, fine, "", invitatiDEM);
      } else {
        const newId = await creaEventoCalendar(accessToken, CALENDARIO_DEM, titolo, inizio, fine, "", invitatiDEM);
        if (newId) nuoviIdEventi[key] = newId;
      }
    }
  }

  // ── REMINDER SURVEY ───────────────────────────────────────
  if (evento.surveyPostEvento && evento.demSurvey) {
    const inizio = sottraiMinuti(evento.demSurvey, 15);
    const fine = aggiungiMinuti(evento.demSurvey, 10);
    const titolo = `Invio DEM - Survey - ${evento.titolo}`;
    const idEsistente = idEventiCalendar["demSurvey"];

    if (azione === "aggiorna" && idEsistente) {
      await aggiornaEventoCalendar(accessToken, CALENDARIO_DEM, idEsistente, titolo, inizio, fine, "", invitatiDEM);
    } else {
      const newId = await creaEventoCalendar(accessToken, CALENDARIO_DEM, titolo, inizio, fine, "", invitatiDEM);
      if (newId) nuoviIdEventi["demSurvey"] = newId;
    }
  }

  // ── REMINDER EVENTO ───────────────────────────────────────
  if (evento.durataGiorni > 1 && evento.giornate?.length > 0) {
    for (let i = 0; i < evento.giornate.length; i++) {
      const giornata = evento.giornate[i];
      if (!giornata.dataInizio || !giornata.oraInizio) continue;
      const inizioISO = new Date(`${giornata.dataInizio}T${giornata.oraInizio}`).toISOString();
      const fineISO = giornata.dataFine && giornata.oraFine
        ? new Date(`${giornata.dataFine}T${giornata.oraFine}`).toISOString()
        : aggiungiMinuti(inizioISO, 60);
      const key = `evento_giorno_${i}`;
      const idEsistente = idEventiCalendar[key];

      if (azione === "aggiorna" && idEsistente) {
        await aggiornaEventoCalendar(accessToken, CALENDARIO_EVENTO, idEsistente, evento.titolo, inizioISO, fineISO, descrizioneEvento, invitatiEvento);
      } else {
        const newId = await creaEventoCalendar(accessToken, CALENDARIO_EVENTO, evento.titolo, inizioISO, fineISO, descrizioneEvento, invitatiEvento);
        if (newId) nuoviIdEventi[key] = newId;
      }
    }
  } else if (evento.dataInizio && evento.oraInizio) {
    const inizioISO = new Date(`${evento.dataInizio}T${evento.oraInizio}`).toISOString();
    const fineISO = evento.dataFine && evento.oraFine
      ? new Date(`${evento.dataFine}T${evento.oraFine}`).toISOString()
      : aggiungiMinuti(inizioISO, 60);
    const idEsistente = idEventiCalendar["evento"];

    if (azione === "aggiorna" && idEsistente) {
      await aggiornaEventoCalendar(accessToken, CALENDARIO_EVENTO, idEsistente, evento.titolo, inizioISO, fineISO, descrizioneEvento, invitatiEvento);
    } else {
      const newId = await creaEventoCalendar(accessToken, CALENDARIO_EVENTO, evento.titolo, inizioISO, fineISO, descrizioneEvento, invitatiEvento);
      if (newId) nuoviIdEventi["evento"] = newId;
    }
  }

  // ── REMINDER TASK SUITECRM ────────────────────────────────
  const dataFineRiferimento = evento.durataGiorni > 1
    ? evento.giornate?.[evento.giornate.length - 1]?.dataFine || evento.giornate?.[evento.giornate.length - 1]?.dataInizio
    : evento.dataFine || evento.dataInizio;

  if (dataFineRiferimento) {
    const inizioTask = giornoSuccessivoOre12(dataFineRiferimento);
    const fineTask = giornoSuccessivoOre1215(dataFineRiferimento);
    const titoloTask = `Reminder di fatturazione - ${evento.titolo}`;
    const idEsistente = idEventiCalendar["taskSuiteCRM"];

    if (azione === "aggiorna" && idEsistente) {
      await aggiornaEventoCalendar(accessToken, CALENDARIO_SUITECRM, idEsistente, titoloTask, inizioTask, fineTask, "", invitatiSuiteCRM);
    } else {
      const newId = await creaEventoCalendar(accessToken, CALENDARIO_SUITECRM, titoloTask, inizioTask, fineTask, "", invitatiSuiteCRM);
      if (newId) nuoviIdEventi["taskSuiteCRM"] = newId;
    }
  }

  console.log("Reminder Calendar gestiti con successo");
  return nuoviIdEventi;
}